import React, { useState, useEffect } from 'react';
import './FENavbar.css';

const FENavbar = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <nav className={`fe-navbar navbar navbar-expand-lg navbar-light${scrolled ? ' fe-navbar--scrolled' : ''}`}>
            <div className="container">
                <a className="navbar-brand fe-navbar__brand" href="/">
                    <img
                        src="/assets/custom/images/coralan-multiservice-logo.png"
                        alt="Coralan Multiservice"
                        className="fe-navbar__logo"
                    />
                </a>

                <button
                    className="navbar-toggler fe-navbar__toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#feNavbarCollapse"
                    aria-controls="feNavbarCollapse"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="feNavbarCollapse">
                    <ul className="navbar-nav mx-auto fe-navbar__nav">
                        <li className="nav-item">
                            <a className="nav-link fe-navbar__link" href="#fe-features">
                                Beneficios
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link fe-navbar__link" href="#fe-pricing">
                                Planes
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link fe-navbar__link" href="#fe-faq">
                                Preguntas
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link fe-navbar__link" href="#fe-hero">
                                Contacto
                            </a>
                        </li>
                    </ul>

                    <div className="fe-navbar__cta">
                        <a href="#fe-hero" className="btn btn-fe-primary fe-navbar__cta-btn">
                            Solicitar Demo
                        </a>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default FENavbar;
